import {
  Box,
  CircularProgress,
  Typography,
  circularProgressClasses,
} from '@mui/material';

function CircularLoading() {
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'block',
        width: 'fit-content',
        margin: 'auto',
        marginTop: '1rem',
      }}
    >
      <CircularProgress
        variant='determinate'
        sx={{
          color: '#dbdbdb',
        }}
        size={70}
        thickness={6}
        value={100}
      />
      <CircularProgress
        variant='indeterminate'
        disableShrink
        sx={{
          color: '#004357',
          animationDuration: '550ms',
          position: 'absolute',
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: 'round',
          },
        }}
        size={70}
        thickness={6}
      />
    </Box>
  );
}

const Loader = () => {
  return (
    <Box
      sx={{
        backgroundColor: 'rgba(50, 71, 92, 0.02)',
        boxShadow:
          '0px 4px 4px rgba(0, 0, 0, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.1)',
        borderRadius: '0 0 10px 10px',
        padding: '1.5rem',
      }}
    >
      <Typography align='center'>
        We are trying to fetch the data for you to join
      </Typography>
      <Box sx={{}}>
        <CircularLoading />
      </Box>
    </Box>
  );
};
export default Loader;
